import React from "react";
import "../styles/greenCoffee.css";
import GreenCoffeeBG from "../assets/images/Green-Coffee-Bg.jpeg";

export default function GreenCoffee() {
  const standardGrades = [
    "Arabica Plantation",
    "Arabica Cherry",
    "Robusta Parchment",
    "Robusta Cherry",
  ];

  const specialGrades = [
    {
      title: "Mysore Nuggets",
      subtitle: "Extra Bold",
      description1: "This wonderful and exotic coffee is prepared using washed Arabicas. The coffee beans are very large, uniformly bluish green in colour, and have a clean polished appearance.",
      description2: "In the cup, the coffee exhibits full aroma, medium to good body, good acidity and a fine flavour.",
      sieveStandard: "Minimum 90% retention on a sieve of 7.5 mm (Screen 19) and 100% retention on a sieve of 6.65 mm (Screen 17).",
      isList: false
    },
    {
      title: "Mysore Malabar",
      subtitle: "Monsooned Coffee",
      description1: "Monsooned Malabar is a unique coffee processed by exposing the beans to monsoon winds in open warehouses. This process causes the beans to swell and turn a pale golden color.",
      description2: "The cup has a distinct earthy flavor with low acidity, full body, and notes of spice and nuts. It's prized for its smooth, mellow taste.",
      sieveStandard: "Minimum 85% retention on a sieve of 7.5 mm (Screen 19) and 100% retention on a sieve of 6.65 mm (Screen 17).",
      isList: false
    },
    {
      title: "Robusta Kaapi Royal",
      subtitle: "Washed Robusta",
      description1: "Thanks to a unique washing process, Indian washed Robustas are closest in taste to that of Arabicas. The beans are bold and round with pointed ends, and grey to bluish grey in colour.",
      description2: "These intensely aromatic coffees have a soft, mild taste with notes of chocolate.",
      sieveStandard: [
        { label: "RKR Screen 18:", text: "Min 90% on 7.1 mm (Screen 18) & 100% on 6.65 mm (Screen 17)." },
        { label: "RKR Screen 17:", text: "Min 90% on 6.65 mm (Screen 17) & 100% on 6.00 mm (Screen 15)." }
      ],
      isList: true
    }
  ];

  return (
    <div className="green-coffee-page">
      {/* Spacer for fixed navbar */}
      <div className="nav-spacer"></div>

      {/* Hero Section */}
      <div
        className="hero-section"
        style={{ backgroundImage: `url(${GreenCoffeeBG})` }}
      >
        {/* Dark Overlay */}
        <div className="hero-overlay"></div>

        {/* Hero Content */}
        <div className="hero-content">
          <div className="hero-badge">
            <span>GLOBAL COMPLIANCE</span>
          </div>

          <h1 className="hero-title">GREEN COFFEE BEANS</h1>

          <p className="hero-subtitle">
            Premium Raw Beans from the Heartland of India
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="container">
          
          {/* Standard Grades Section */}
          <section className="standard-grades-section">
            <div className="section-header">
              <div className="section-badge">
                <div className="badge-line left"></div>
                <span className="badge-text">OUR COLLECTION</span>
                <div className="badge-line right"></div>
              </div>
              <h2 className="section-title">Standard Grades</h2>
              <p className="section-description grades-availability-text">
                All GRADES Available
              </p>
            </div>
            
            <div className="grades-grid-new">
              {standardGrades.map((grade, index) => (
                <div key={index} className="grade-card-simple">
                  <div className="grade-number">{String(index + 1).padStart(2, '0')}</div>
                  <h3 className="grade-title">{grade}</h3>
                  <div className="grade-accent-line"></div>
                </div>
              ))}
            </div>
          </section>

          {/* Artistic Divider */}
          <div className="divider-section">
            <div className="divider-content">
              <div className="divider-dots left">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
              <div className="divider-line left"></div>
              <div className="divider-center-dot"></div>
              <div className="divider-line right"></div>
              <div className="divider-dots right">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          </div>

          {/* Special Grades Section */}
          <section className="special-grades-section">
            <div className="section-header">
              <div className="section-badge">
                <div className="badge-line left"></div>
                <span className="badge-text">PREMIUM SELECTION</span>
                <div className="badge-line right"></div>
              </div>
              <h2 className="section-title">Special Grades</h2>
              <p className="section-description">
                Exceptional coffees with distinctive characteristics
              </p>
            </div>

            <div className="special-grades-grid">
              {specialGrades.map((grade, index) => (
                <div key={index} className="special-card">
                  <div className="special-card-top-line"></div>
                  
                  <div className="special-card-content">
                    <div className="special-card-header">
                      <div className="special-card-badge">
                        <div className="special-icon">
                          <div className="special-icon-box"></div>
                        </div>
                        <div className="special-divider"></div>
                        <span className="special-badge-text">PREMIUM</span>
                      </div>
                      
                      <h3 className="special-title">{grade.title}</h3>
                      <p className="special-subtitle">{grade.subtitle}</p>
                    </div>
                    
                    <div className="special-description">
                      <p>{grade.description1}</p>
                      <p>{grade.description2}</p>
                    </div>
                    
                    <div className="sieve-info">
                      <div className="sieve-bar"></div>
                      
                      <div className="sieve-content">
                        <div className="sieve-header">
                          <div className="sieve-icon">
                            <div className="sieve-icon-inner"></div>
                          </div>
                          <span className="sieve-label">SIEVE STANDARD</span>
                        </div>
                        
                        {grade.isList ? (
                          <div className="sieve-list">
                            {grade.sieveStandard.map((item, idx) => (
                              <div key={idx} className="sieve-item">
                                <div className="sieve-bullet"></div>
                                <p>
                                  <strong>{item.label}</strong> {item.text}
                                </p>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="sieve-text">{grade.sieveStandard}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}